<template>
    <div>
        <ul class="flex-center calendar">
            <li class="last flex-center cursor" @click="lastDate" :class="{'star-date':starStatu}"> <i class="el-icon-caret-left"></i></li>
            <li class="calendarList cursor">
                <div class="calendaritem flex-center float-left cursor" v-for="(item,zindex) in weekPrice" :class="{'calendaritem-show':active==zindex}" :key="zindex" @click="active = zindex,getDayItem(item,zindex)">
                    <div>
                       <p class="font-13 flex-center"><span>{{item.date}}</span><span>{{item.week}}</span></p>
                       <p class="flex-center"><span class="font-10">¥</span>
                       {{item.distributorPrice}}
                       <span class="font-10">起</span></p>
                    </div>
                </div>
            </li>
            <li class="next flex-center cursor" @click="nextDate"> <i class="el-icon-caret-right"></i></li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return{
            active:0,
            weekList:[],
            startDay:'',//日历第一个日期
            endDay:'',//日历最后一个日期
            starStatu:false,
            selectDate:{}
        }
    },
    created(){
        // this.getList()
    },
    props:['weekPrice','index','dayColor','formData'],
    watch:{
        weekPrice(val){
            this.showDate(val)
        }
    },
    methods:{
        getList(val){
            let arr = []
            val?val:''
            for(let i = 0;i<7;i++){
                let dateTime = this.$moment(val).subtract(-i, 'days').format('YYYY-MM-DD')
                let time = this.$moment(val).day(-i)._d
                let week = time.getDay()
               week =  week===0?'星期日':week===1?'星期一':week===2?'星期二':week===3?'星期三':week===4?'星期四':week===5?'星期五':'星期六'
                let obj = {
                    week:week,
                    date:dateTime
                }
                arr.push(obj)
            }
            this.weekList = arr
            let data  = {
                weekList:this.weekList,
                checkInDate:arr[0].date,
                checkOutDate:arr[6].date,
                index:this.index
            }
            this.startDay = arr[0].date
            this.endDay = arr[6].date
            this.$emit('weekInfo',data)
        },
        //单击月份
        getDayItem(val,index){
            let data={
                index:this.index,
                sindex:index,
                date:val
            }
            console.log(this.formData)
            this.selectDate={date:val.date.replace(/\/\$/g,"/"),index:index}
            this.$emit('clickNowDate',data)
        },
        //下一页
        nextDate(){
            this.starStatu = true
            let data = {
                index:this.index,
                date:this.getTime(6).replace(/-/g,"/")
            }
            this.active = null
            this.$emit('clickDate',data)
            // console.log(this.selectDate)
        },
        //显示选中日期
        showDate(list){
           if(Object.keys(this.selectDate).length===0)return
           for(let i in list){
               if(list[i].date==this.selectDate.date){
                    this.active = i
                    return
                }else{
                    this.active = null
                }
            }
        },
        //上一页
        lastDate(){
            if(!this.starStatu)return
            let today = this.$moment(this.$moment(this.formData.checkInTime).format('YYYY-MM-DD'))._d
            let lastToday = this.$moment(this.getTime(0)).subtract('days', 6)._d
            let data = {
                index:this.index,
                date:this.$moment(this.getTime(0)).subtract('days', 6).format('YYYY/MM/DD')
            }
            this.$emit('clickDate',data)
            if(today>=lastToday){
                if(Object.keys(this.selectDate).length===0) {this.active = 0}
                this.starStatu = false
            }
        },
        getTime(i){
            return  this.weekPrice[i].date
        }
    }
}
</script>
<style lang="less" scoped>
.calendar{
    overflow: hidden;
    margin: 0 10px 21px 10px;
    li{
        // border: 1px solid #ccc;
        list-style: none;
        height: 60px;
    }
    .last{
        width: 51px;
        font-size: 23px;
        border: 1px solid #ccc;
        border-right:0;
        color: #ccc;
        z-index: 999;
        background: white;
    }
    .next{
        width: 51px;
        font-size: 23px;
        background: white;
        color: #237dc8;
        border: 1px solid #ccc;
        border-left:0;
    }
    .star-date{
        color: #237dc8;
    }
    .calendarList{
        width: 95%;
        transition: all 5s ease;
        overflow: hidden;
    }
    .calendaritem-show{
        background: white !important;
         &::before{
            content: '';
            position: absolute;
            top: -2px;
            display: block;
            width: 100%;
            height: 4px;
            background:#237dc8;
        }
    }
    .calendaritem{
        width: 14.28%;
        height: 100%;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        position: relative;
        background: #f8feff;
        &:nth-child(1){
            border-left: 1px solid #ccc;
        }
        p{
            color: #ff6600;
            &:nth-child(1){
                color: #7d7d7d;
                padding-bottom: 5px;
                span{
                    padding: 0 5px;
                }
            }
            &:nth-child(2){
                span{
                    transform: translateY(2px);
                    padding: 0 3px;
                }
            }
        }
    }
}
</style>
